module.exports = __webpack_public_path__ + "img/dsci0057.3ff9bdb3.jpg";